import { Box } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';

const shimmer = keyframes`
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;

/** Shimmer placeholder shown inside a widget card while its data is loading. */
const WidgetShimmer = () => (
  <Box
    height='100%'
    width='100%'
    borderRadius='8px'
    background='linear-gradient(90deg, #F0EEFA 25%, #F8F7FC 37%, #F0EEFA 63%)'
    backgroundSize='800px 100%'
    animation={`${shimmer} 1.6s ease-in-out infinite`}
  />
);

export default WidgetShimmer;
